import { ReduceStore } from 'flux/utils';
import Dispatcher from './Dispatcher';
import Constants from './Constants';

class OnlinePurchaseStore extends ReduceStore {
  constructor() {
    super(Dispatcher);
  }

  getInitialState() {
    return null;
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.APP_SET_ONLINE_PURCHASE:
        return action.onlinePurchase;

      default:
        return state;
    }
  }
}

export default new OnlinePurchaseStore();



// WEBPACK FOOTER //
// ./src/flux/OnlinePurchaseStore.js